import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LOGO } from '../../../core/models/logo.enum';
import { Position } from '../../../core/models/Position';
import { GtSessionStorageService } from '../../../core/services/gt-session-storage.service';
import { UtilsService } from '../../../core/services/utils';
import { OAuthConstants } from '../../constant/oAuth.constants';
import { DomainDataService } from '../../../core/services/domain-data.service';
import { LoginService } from '../../../core/services/login.service';
import { LogoutPage } from '../../models/logout/LogoutPage';
import { oAuthRoutes } from '../../oauth.routes';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: true
})
export class LogoutComponent implements OnInit {
  public domainName: string;
  public logoPosition = Position.CENTER;
  public logoType = LOGO.CLIENT;
  public emoji = '&#128522;';
  private samlEnabled = false;
  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute,
              private utils: UtilsService,
              private cookieService: CookieService,
              private gtSessionStorageService: GtSessionStorageService,
              private loginService: LoginService,
              @Inject(DOCUMENT) private document: any,
              private _domainDataService: DomainDataService) {
  }

  public ngOnInit() {
    const domain = window.location.host;
    this.domainName = window.btoa(domain);
    this._domainDataService.setDomain(this.domainName);
    this.loginService.getLogoutPageResposne(this.domainName)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: LogoutPage) => {
        this.samlEnabled = res.samlEnabled;
      });
    this.cookieService.deleteAll('/', domain);
    this.gtSessionStorageService.removeAll();
  }

  public returnTologin() {
    const redirectUrl = this.samlEnabled ? OAuthConstants.SAML_LOGIN_ROUTE : OAuthConstants.LOGIN_ROUTE;
    this.document.location.href = this.document.location.origin + redirectUrl;
  }

}
